import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  banner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#1e2a5e',
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2.5, 3),
    gap: theme.spacing(2),
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
    color: '#ffffff',
    lineHeight: 1.4,
  },
  subtitle: {
    fontSize: 13,
    fontWeight: 400,
    color: 'rgba(255, 255, 255, 0.65)',
    lineHeight: 1.4,
  },
  button: {
    flexShrink: 0,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap',
    backgroundColor: theme.palette.info.main,
    color: theme.palette.common.white,
    '&:hover': {
      backgroundColor: theme.palette.info.dark,
    },
  },
}))

export default useStyles
